<template>
  <v-form
    ref="form"
    lazy-validation
    v-model="formValid"
    v-if="item != null"
  >
    <v-alert
      :value="formError"
      color="error"
      class="pb-2"
    >{{ formError }}
    </v-alert>

    <v-text-field
      v-model="item.name"
      :label="$t('name')"
      :rules="[v => !!v || $t('name_required')]"
      required
      :disabled="formSaving"
      outlined
      dense
    ></v-text-field>

    <v-text-field
      v-model.trim="item.image"
      :label="$t('eeImage')"
      :placeholder="$t('eeImagePlaceholder')"
      :rules="[v => !!v || $t('eeImageRequired')]"
      required
      :disabled="formSaving"
      outlined
      dense
    ></v-text-field>

    <v-select
      v-model="item.pull_policy"
      :label="$t('eePullPolicy')"
      :items="pullPolicies"
      item-value="id"
      item-text="name"
      :disabled="formSaving"
      outlined
      dense
    ></v-select>

    <v-autocomplete
      v-model="item.registry_credential_key_id"
      :label="$t('eeRegistryCredential')"
      :items="loginPasswordKeys"
      item-value="id"
      item-text="name"
      :hint="$t('eeRegistryCredentialHint')"
      persistent-hint
      clearable
      :disabled="formSaving"
      outlined
      dense
    ></v-autocomplete>

    <v-alert
      type="info"
      dense
      text
      class="mt-2"
    >
      {{ $t('eeHint') }}
    </v-alert>
  </v-form>
</template>
<script>
import axios from 'axios';
import ItemFormBase from '@/components/ItemFormBase';

export default {
  mixins: [ItemFormBase],

  data() {
    return {
      pullPolicies: [
        { id: 'if_not_present', name: 'If Not Present (default)' },
        { id: 'always', name: 'Always' },
        { id: 'never', name: 'Never' },
      ],
      keys: [],
    };
  },

  computed: {
    // Only login_password keys make sense for `docker login` — ssh / none
    // would have nothing to authenticate the registry with.
    loginPasswordKeys() {
      return (this.keys || []).filter((k) => k.type === 'login_password');
    },
  },

  async created() {
    try {
      const { data } = await axios.get(`/api/project/${this.projectId}/keys`);
      this.keys = Array.isArray(data) ? data : [];
    } catch (e) {
      this.keys = [];
    }
  },

  methods: {
    getItemsUrl() {
      return `/api/project/${this.projectId}/execution_environments`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/execution_environments/${this.itemId}`;
    },
    getNewItem() {
      return {
        name: '',
        image: '',
        pull_policy: 'if_not_present',
        registry_credential_key_id: null,
      };
    },
  },
};
</script>
